export default "__VITE_ASSET__aNMvn73Q__"